import { render, staticRenderFns } from "./designAssistant.vue?vue&type=template&id=b33cedc6&"
import script from "./designAssistant.vue?vue&type=script&lang=js&"
export * from "./designAssistant.vue?vue&type=script&lang=js&"
import style0 from "./designAssistant.vue?vue&type=style&index=0&id=b33cedc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports